import { cn } from "@/lib/utils";

export function HorizontalScrollRow({
  className,
  ref,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      ref={ref}
      className={cn(
        "-mx-4 md:mx-0 flex gap-3 overflow-x-auto pb-2 px-4 md:px-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        className,
      )}
      {...props}
    />
  );
}
